// Copyright (c) 2016 Deere & Company

import {getDefaultState as getClaimPartDefaultState} from '@deere/cps-it.warranty-model-factory/lib/claim-item-part';
import {getDefaultState as getLaborDefaultState} from '@deere/cps-it.warranty-model-factory/lib/claim-item-labor';
import {getDefaultState as getOtherCreditDefaultState} from '@deere/cps-it.warranty-model-factory/lib/claim-item-other-credit';

export const addEmptyClaimRows = (claim, Claim) => {

    let updatedClaim;

    updatedClaim = claim;

    if (!claim.parts.length) {

        updatedClaim = Claim.update(updatedClaim, {
            parts: {
                $push: [getClaimPartDefaultState()]
            }
        });

    }

    if (!claim.labor.length) {

        updatedClaim = Claim.update(updatedClaim, {
            labor: {
                $push: [getLaborDefaultState()]
            }
        });

    }

    if (!claim.otherCredits.length) {

        updatedClaim = Claim.update(updatedClaim, {
            otherCredits: {
                $push: [getOtherCreditDefaultState()]
            }
        });

    }

    return updatedClaim;

};

const removeEmptyParts = parts => parts.filter(part => (part.partNumber) || (part.unit.key));
const removeEmptyLabors = labors => labors.filter(labor => (labor.laborHours) || (labor.techId) || (labor.location.key) || (labor.laborType.key));
const removeEmptyOtherCredits = otherCredits => otherCredits.filter(credit => (credit.details.key) || (credit.amount) || (credit.distance));

export const removeEmptyRows = (claim, Claim) =>
    Claim.update(claim, {
        $merge: {
            labor: removeEmptyLabors(claim.labor),
            otherCredits: removeEmptyOtherCredits(claim.otherCredits),
            parts: removeEmptyParts(claim.parts)
        }
    });



// WEBPACK FOOTER //
// ./src/claim/shared/services/empty-claim-rows.js